import { requestCreator, UnknownError } from "../../common/actions/VisitApi";
import { CompanyFollowing } from "../../entities";

export const requestToFollowCompany = requestCreator<EntityId, CompanyFollowing, UnknownError>(companyId => ({
  path: `/api/v2/company_followings`,
  method: "POST",
  body: {
    company_id: companyId,
  },
}));

export const requestToUnfollowCompany = requestCreator<EntityId, null, UnknownError>(companyId => ({
  path: `/api/v2/company_followings`,
  method: "DELETE",
  body: {
    company_id: companyId,
  },
}));



// WEBPACK FOOTER //
// ./frontend/src/company_followings/api/index.ts